module.exports = __webpack_public_path__ + "img/payment_recived.0baecdf2.png";